import classNames from 'classnames/bind'
import { HTMLAttributes, ReactNode } from 'react'
import styles from './style.module.scss'

const cx = classNames.bind(styles)

export type RoomInfoType = {
  roomId: string
  startTime: string
}

export type LiveFeedItemButton = {
  children: ReactNode
  onClick: (roomInfo: RoomInfoType) => void
}

export type LiveFeedItemButtonsProps = {
  buttons: LiveFeedItemButton[]
  roomInfo: RoomInfoType
}

const Button = ({ children, onClick }: { children: ReactNode; onClick: () => void }) => {
  return (
    <button onClick={onClick} className={cx('button')}>
      {children}
    </button>
  )
}

const LiveFeedItemButtons = ({ buttons, roomInfo, ...props }: HTMLAttributes<HTMLDivElement> & LiveFeedItemButtonsProps) => {
  return (
    <div className={cx('buttons', props.className)} {...props}>
      {buttons.map((button, index) => (
        <Button key={index} onClick={() => button.onClick(roomInfo)}>
          {button.children}
        </Button>
      ))}
    </div>
  )
}

export default LiveFeedItemButtons
